import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { ForgeIconButtonModule, ForgeIconModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { FocusOnLoadDirective } from "../../../../directives/focusOnLoad.directive";
import { MetadataTextButtonComponent } from "./metadata-text-button.component";

@Component({
    selector: "metadata-icon-button",
    templateUrl: "./metadata-icon-button.tmpl.html",
    imports: [
        ClassDirective,
        FocusOnLoadDirective,
        ForgeIconButtonModule,
        ForgeIconModule,
        ForgeTooltipModule,
        NgClass,
    ]
})
export class MetadataIconButtonComponent extends MetadataTextButtonComponent
{

}
